import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ApolloProvider } from 'react-apollo';
import { ApolloProvider as ApolloHooksProvider } from '@apollo/react-hooks';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import './fonts.css';

import Navigation from './components/navigation/navigation';
import RouterSAV from './router/router';

import storage from './providers/storage';
import RouterFactory from './router/routerFactory';
import Client from './providers/apolloClient';
import { GET_MY_ROLES } from './query/query';

// Same shape as savLoginWithPassword's roles: { savagent: true, ... }
const rolesAsFlags = (roleList) => roleList.reduce(
  (flags, role) => ({ ...flags, [role]: true }), {},
);

class App extends Component {
  constructor(props) {
    super(props);

    const client = Client.getClient();
    const token = storage.getToken();
    const email = storage.getEmail();
    const roles = storage.getRoles() || {};

    this.state = {
      logEmail: email,
      token,
      client,
      roles,
    };

    this.handleLogin = this.handleLogin.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }

  componentDidMount() {
    this.refreshRoles();
  }

  handleLogin(email, token, roles) {
    storage.setStorage(token, email, roles);
    const client = Client.getClient();

    this.setState({
      logEmail: email,
      token,
      roles,
      client,
    });
  }

  handleLogout() {
    storage.clear();
    const client = Client.getClient();

    this.setState({
      logEmail: '',
      token: null,
      client,
      roles: {},
    });
  }

  // Roles are saved at login; read them again from the API on every load so a
  // role granted or removed applies without logging out, and a dead token logs out.
  refreshRoles() {
    const { token, client } = this.state;
    if (!token) {
      return;
    }
    client.query({ query: GET_MY_ROLES, fetchPolicy: 'network-only' })
      .then(({ data }) => {
        const roleList = data && data.me && data.me.roles;
        if (!roleList || !roleList.length) {
          this.handleLogout();
          return;
        }
        const roles = rolesAsFlags(roleList);
        storage.setRoles(roles);
        this.setState({ roles });
      })
      // Network trouble: keep the roles saved at login rather than logging out.
      .catch(() => {});
  }

  render() {
    const {
      logEmail, token, roles, client,
    } = this.state;
    return (
      <ApolloProvider client={client}>
        <ApolloHooksProvider client={client}>
          <div className="App container" style={{ maxWidth: 1500 }}>
            {
              roles.factory
                ? <RouterFactory />
                : (
                  <div>
                    <Navigation
                      logEmail={logEmail}
                      token={token}
                      onLogout={this.handleLogout}
                      roles={roles}
                    />
                    <RouterSAV
                      onLogin={this.handleLogin}
                      token={token}
                      roles={roles}
                    />
                  </div>
                )
            }
          </div>
        </ApolloHooksProvider>
      </ApolloProvider>
    );
  }
}

// eslint-disable-next-line no-undef
ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js